// Аптечка и гарантии: вещи со сроком — лекарство (годен до) или гарантия на покупку (действует до).
import { z } from "zod";
import { dueDateFor } from "./debts.ts";

export type HomeItemKind = "medicine" | "warranty";

/** За сколько дней до срока подсвечивать «скоро» и напоминать в боте. */
export const HOME_ITEM_SOON_DAYS = 30;

export interface HomeItemDto {
  id: string;
  kind: HomeItemKind;
  name: string;
  /** YYYY-MM-DD: годен до / гарантия до. */
  expiresOn: string;
  /** Гарантия: дата покупки. */
  boughtOn: string | null;
  note: string | null;
  photoFileId: string | null;
  /** Готовая ссылка на фото (с токеном семьи). */
  photoUrl: string | null;
  /** Дней до срока: 0 — сегодня последний день, < 0 — срок прошёл. */
  daysLeft: number;
  status: "ok" | "soon" | "expired";
}

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

export const HomeItemSchema = z.object({
  kind: z.enum(["medicine", "warranty"]),
  name: z.string().trim().min(1).max(80),
  expiresOn: isoDate,
  boughtOn: isoDate.nullable().default(null),
  note: z.string().trim().max(200).nullable().default(null),
  fileId: z.string().uuid().nullable().default(null),
});
export type HomeItemInput = z.input<typeof HomeItemSchema>;

/** Дата + N месяцев: 31 января + 1 месяц → 28 (29) февраля. */
export function addMonths(date: string, months: number): string {
  return dueDateFor(date, months, Number(date.slice(8, 10)));
}

/** «Годен до 05.2027» с упаковки — последний день мая 2027. */
export function endOfMonth(year: number, month: number): string {
  const last = new Date(Date.UTC(year, month, 0)).getUTCDate();
  return `${year}-${String(month).padStart(2, "0")}-${String(last).padStart(2, "0")}`;
}

/** Сколько дней осталось и как подсветить. */
export function homeItemStatus(expiresOn: string, today: string): { daysLeft: number; status: HomeItemDto["status"] } {
  const daysLeft = Math.round((Date.parse(`${expiresOn}T00:00:00Z`) - Date.parse(`${today}T00:00:00Z`)) / 86_400_000);
  return { daysLeft, status: daysLeft < 0 ? "expired" : daysLeft <= HOME_ITEM_SOON_DAYS ? "soon" : "ok" };
}
